module.exports = __webpack_public_path__ + "img/services-icon3.27d870f3.png";